export default __webpack_public_path__ + "static/media/home-login.c78a5631.jpg";